import { data } from "jquery";

const sidePanReducer = (state = {}, action) => {
    switch (action.type) {
        case "ShowSidePan":
            return Object.assign({}, state, {
                sidePan: action.data,
            });
            break;
        case "MDSDocCollectAll":
            return Object.assign({}, state, {
                MDSDocCollectAll: action.data,
            });
            break;
            case "isInPoValidation":
            return Object.assign({}, state, {
                isInPoValidation: action.data,
            });
            break;
        case "ShowStaffPendingTaskPanel":
            return Object.assign({}, state, {
                ShowStaffPendingTaskPanel: action.data,
            });
            break;
        case "ShipRole":
            return Object.assign({}, state, {
                shipRole: action.data,
            });
            break;
        case "ResetMI":
            return Object.assign({}, state, {
                ResetMI: action.data,
            });
            break;
        case "ResetMD":
            return Object.assign({}, state, {
                ResetMD: action.data,
            });
            break;
        case "ResetSMD":
            return Object.assign({}, state, {
                ResetSMD: action.data,
            });
            break;
        case "ResetGD":
            return Object.assign({}, state, {
                ResetGD: action.data,
            });
            break;
        case "Refresh":
            return Object.assign({}, state, {
                Refresh: action.data,
            });
            break;
        case "MDDetail":
            return Object.assign({}, state, {
                MDLib: true,
            });
            break;
        case "Otherpages":
            return Object.assign({}, state, {
                MDLib: false,
            });
            break;
        case "SMD Library":
            return Object.assign({}, state, {
                sidePan: action.data,
                SubBannerTitle: 'SDoC LIBRARY'
            });
            break;
        case "GD Library":
            return Object.assign({}, state, {
                sidePan: action.data,
                SubBannerTitle: 'GD Library'
            });
            break;
        case "MD Library":
            return Object.assign({}, state, {
                sidePan: action.data,
                SubBannerTitle: 'MD Library'
            });
            break;
        case "Reports":
            return Object.assign({}, state, {
                sidePan: action.data,
                SubBannerTitle: 'Reports'
            });
            break;
        case "User":
            return Object.assign({}, state, {
                sidePan: action.data,
                SubBannerTitle: 'User'
            });
            break;
        case "Staff":
            return Object.assign({}, state, {
                sidePan: action.data,
                SubBannerTitle: 'My Pending Tasks'
            });
            break;
        case "Certificates":
            return Object.assign({}, state, {
                sidePan: action.data,
                SubBannerTitle: 'Certificates'
            });
            break;
        case "MaintenanceRevision":
            return Object.assign({}, state, {
                sidePan: action.data,
                SubBannerTitle: 'IHM Maintenance Revision'
            });
            break;
        case "HazardessMaterial":
            return Object.assign({}, state, {
                sidePan: action.data,
                SubBannerTitle: 'PO Hazardess Material Validation'
            });
            break;
        case "POView":
            return Object.assign({}, state, {
                sidePan: action.data,
                SubBannerTitle: 'PO View'
            });
            break;
        case "Client Dashboard":
            return Object.assign({}, state, {
                sidePan: action.data,
                SubBannerTitle: 'Client Dashboard'
            });
            break;
        case "MMPL Dashboard":
            return Object.assign({}, state, {
                sidePan: action.data,
                SubBannerTitle: 'MMPL Dashboard'
            });
            break;
        case "SubMenuItems":
            return Object.assign({}, state, {
                SubMenuItems: action.data
            });
            break;
        case "EditPendingTaskRevision":
            return Object.assign({}, state, {
                EditPendingTaskRevision: action.data,
            });
            break;
        case "EditPendingTaskPresence":
            return Object.assign({}, state, {
                EditPendingTaskPresence: action.data,
            });
            break;
        case "ShowMISidePan":
            return Object.assign({}, state, {
                ShowMISidePan: action.data,
                ShowRDSidePan: false,
                ShowEURegSidePan: false
            });
            break;
        case "ShowRDSidePan":
            return Object.assign({}, state, {
                ShowMISidePan: false,
                ShowRDSidePan: action.data,
                ShowEURegSidePan: false
            });
            break;
        case "ShowEURegSidePan":
            return Object.assign({}, state, {
                ShowMISidePan: false,
                ShowRDSidePan: false,
                ShowEURegSidePan: action.data
            });
            break;
        case "GetMDSearchSuccess":
            return Object.assign({}, state, {
                arraylist: action.data,
                MDDeleteSuccess: false
            });
        case "MDSearchIsTrue":
            return Object.assign({}, state, {
                isMDSearch: true,
                MDSearchData: action.data
            })
            break;
        case "GetMDDetailFailure":
            return Object.assign({}, state, {
                e: action.data
            });
            break;
        case "GetMDDetailSuccess":
            return Object.assign({}, state, {
                mdDetailList: action.data
            });
            break;
        case "GetOthersMISuccess":
            return Object.assign({}, state, {
                MIOthersList: action.data
            });
            break;
        case "GetOthersMIFailure":
            return Object.assign({}, state, {
                ee: action.data
            });
            break;
        case "GetOthersEUSuccess":
            return Object.assign({}, state, {
                MIEuList: action.data
            });
            break;
        case "GetOthersEUFailure":
            return Object.assign({}, state, {
                ee: action.data
            });
            break;
        case "PostMaterialDeclarationSuccess":
            return Object.assign({}, state, {
                declarationID: action.data
            });
            break;
        case "PostMaterialDeclarationFailure":
            return Object.assign({}, state, {
                ee: action.data
            });
            break;
        case "EmptyMdDetailList":
            return Object.assign({}, state, {
                mdDetailList: []
            });
            break;
        case "ClearMdDetailList":
            return Object.assign({}, state, {
                mdDetailList: []
            });
            break;
        case "MDDeleteSuccess":
            return Object.assign({}, state, {
                MDDeleteSuccess: true,
                sidePan: false
            });
            break;
        case "getMDRelatedDocuments":
            return Object.assign({}, state, {
                RDList: action.data
            });
            break;
        case "AttchmentUploaded":
            return Object.assign({}, state, {
                attachmentDetail: action.data,
                isAttachment: true,
            })
            break;
        case "SDocAttchmentUploaded":
            return Object.assign({}, state, {
                MdAttachment: action.data,
            })
            break;
        case "SMDDeleteSuccess":
            return Object.assign({}, state, {
                SMDisDeleted: true
            })
            break;
        case "GDDeleteSuccess":
            return Object.assign({}, state, {
                GDisDeleted: true
            })
            break;
        // case "SMDupdateSuccess":
        //    return Object.assign({}, state, {
        //       SMDisUpdated: true
        //   })
        //   break;
        case "SMDUpdate":
            return Object.assign({}, state, {

                SMDisUpdated: action.data
            })
            break;
        case "GDUpdate":
            return Object.assign({}, state, {

                GDisUpdated: action.data
            })
            break;
        case "SMDDelete":
            return Object.assign({}, state, {
                SMDisDeleted: action.data
            })
            break;
        case "GDDelete":
            return Object.assign({}, state, {
                GDisDeleted: action.data
            })
            break;
        case "GetMaterialDetailsSuccess":
            return Object.assign({}, state, {
                MInfoList: action.data
            });
            break;
        case "GetMaterialDetailsFailure":
            return Object.assign({}, state, {
                arraylist: action.data
            });
            break;
        case "GetMDRemarkSuccess":
            return Object.assign({}, state, {
                RemarksList: action.data
            });
            break;
        case "GetMDRemarkFailure":
            return Object.assign({}, state, {
                arraylist: action.data
            });
            break;
        case "PostMDRemarkSuccess":
            return Object.assign({}, state, {
                MDRemarksList: action.data
            });
            break;
        case "PostMDRemarkFailure":
            return Object.assign({}, state, {
                arraylist: action.data
            });
            break;
        case "GetReportListSuccess":
            return Object.assign({}, state, {
                ReportList: action.data
            })
            break;
            case "GetReportCountListSuccess":
                return Object.assign({}, state, {
                    ReportCountList: action.data
                })
                break;
        case "IsEditUser":
            return Object.assign({}, state, {
                IsEditUser: action.data
            })
        case "IsSMDEdit":
            return Object.assign({}, state, {
                IsSMDEdit: action.data
            })
            break;
        case "IsGDEdit":
            return Object.assign({}, state, {
                IsGDEdit: action.data
            })
            break;
        case "SMDEditing":
            return Object.assign({}, state, {
                SMDEditing: action.data
            })
            break;
        case "GDEditing":
            return Object.assign({}, state, {
                GDEditing: action.data
            })
            break;
        case "ErrorMessage":
            return Object.assign({}, state, {
                ErrorMessage: action.data
            })
            break;
        case "AuthenticatedUserInformation":
            return Object.assign({}, state, {
                isAuthenticated: action.data.isAuthenticated,
                userDetail: action.data
            })
            break;
        case "UserRole":
            return Object.assign({}, state, {
                UserRole: action.data
            })
            break;
        case "getUserRoleSuccess":
            return Object.assign({}, state, {
                UserRoles: action.data
            })
            break;
        case "GetSMDSearchSuccess":
            return Object.assign({}, state, {
                SMDListData: action.data
            })
            break;
        case "SMDAttchmentUploadSuccess":
            return Object.assign({}, state, {
                SMDAttachmentData: action.data
            })
            break;
        case "SMDAttchmentClear":
            return Object.assign({}, state, {
                SMDAttachmentData: ""
            })
            break;
        case "SMDPostSuccessfull":
            return Object.assign({}, state, {
                IsSMDDataAdded: action.data
            })
            break;
        case "GetGDSearchSuccess":
            return Object.assign({}, state, {
                GDListData: action.data
            })
            break;
        case "GDAttchmentUploadSuccess":
            return Object.assign({}, state, {
                GDAttachmentData: action.data
            })
            break;
        case "GDAttchmentClear":
            return Object.assign({}, state, {
                GDAttachmentData: ""
            })
            break;
        case "GDPostSuccessfull":
            return Object.assign({}, state, {
                IsGDDataAdded: action.data
            })
            break;
        case "getUserDataSuccess":
            return Object.assign({}, state, {
                userList: action.data
            })
            break;
        case "UpdateUserSuccess":
            return Object.assign({}, state, {
                isUserUpdated: action.data
            })
            break;
        case "UserDeleteSuccess":
            return Object.assign({}, state, {
                isUserDeleted: action.data
            })
            break;
        case "PostUserSuccess":
            return Object.assign({}, state, {
                isUserAdded: action.data
            })
            break;
        case "UserAuthenticationSuccess":
            return Object.assign({}, state, {
                IsAuthenticatedUser: action.data
            })
            break;
        case "EditPOView":
            return Object.assign({}, state, {
                EditPOView: action.data
            })
            break;
        case "PurchaseOrders":
            return Object.assign({}, state, {
                PurchaseOrders: action.data
            })
            break;
        case "ShowStaffPendingTaskPanel":
            return Object.assign({}, state, {
                ShowStaffPendingTaskPanel: action.data
            })
            break;
        case "ShowPODetail":
            return Object.assign({}, state, {
                ShowPODetail: action.data
            })
            break;
        case "ADUsersSuccess":
            return Object.assign({}, state, {
                ADUsersList: action.data
            })
        case "getClientShipCountSuccess":
            return Object.assign({}, state, {
                ClientShipCount: action.data,
            });
            break;
        case "getClientShipDetailSuccess":
            return Object.assign({}, state, {
                ClientShipDetails: action.data,
            });
            break;
        case "ShowShipDetails":
            return Object.assign({}, state, {
                ShowShipDetails: action.data,
            });
            break;
        case "EditShipDetails":
            return Object.assign({}, state, {
                EditShipDetails: action.data,
            });
            break;
        case "ShowEquipmentDetails":
            return Object.assign({}, state, {
                ShowEquipmentDetails: action.data,
            });
            break;
        case "EditEquipmentDetails":
            return Object.assign({}, state, {
                EditEquipmentDetails: action.data,
            });
            break;
        case "ShowMMPLDetails":
            return Object.assign({}, state, {
                ShowMMPLDetails: action.data,
            });
            break;
        case "SubBannerTitle":
            return Object.assign({}, state, {
                SubBannerTitle: action.data
            });
            break;
        case "ShowSidePan":
            return Object.assign({}, state, {
                sidePan: action.data,
            });
            break;
        default: {
            return state;
        }
    }
}
export default sidePanReducer;